// src/components/atoms/Profile/Edit/BioLabel.js

import React from "react";
import { Typography, Grid } from "@mui/material";

const BioLabel = () => {
  return (
    <Grid item xs={12} sm={3} sx={{ textAlign: "right" }}>
      <Typography
        variant="body1"
        sx={{ fontFamily: "basic-sans", fontSize: "1em" }}
      >
        Bio
      </Typography>
    </Grid>
  );
};

export default BioLabel;
